import state from "./state.js";
import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

const tipsModule = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {}
};

export const TIPS_MODULE = tipsModule;
export default tipsModule;
